module.exports = __webpack_public_path__ + "static/media/account-feature-documents.d4612ec2.png";